import type { GoodsData } from '@banhala/ui-kit';
import type { GoodsListItem } from 'shared/src/api';
import { isNotNil } from 'shared/src/utils';
import { convertRenderDataToGoodsData } from 'shared/src/utils/convertRenderDataToGoodsData';

export type GoodsListCardItem = GoodsData & {
  item: GoodsListItem;
  logging: GoodsListItem['logging'];
  render: GoodsListItem['render'];
};

export const convertGoodsListItemToGoodsData = (
  goods: GoodsListItem,
): GoodsListCardItem => {
  const rawPriceDescription = goods.render.data.price_description;
  const renderableInput = {
    item: {
      sno: goods.sno,
      delivery_type: goods.delivery_type,
      hasAd: isNotNil(goods.ad),
    },
    render: {
      ...goods.render,
      data: {
        ...goods.render.data,
        price_description:
          typeof rawPriceDescription === 'string'
            ? { text: rawPriceDescription }
            : (rawPriceDescription ?? null),
      },
    },
  };

  return {
    ...convertRenderDataToGoodsData(renderableInput),
    item: goods,
    logging: goods.logging,
    render: goods.render,
  };
};
